import * as React from 'react';
import { cn } from '../../lib';

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'text' | 'circular' | 'rectangular';
  width?: string | number;
  height?: string | number;
}

const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(
  ({ className, variant = 'text', width, height, ...props }, ref) => {
    const baseStyles = cn(
      'animate-shimmer rounded bg-gradient-to-r from-muted via-muted/50 to-muted bg-[length:200%_100%]',
      {
        'h-4 max-w-[250px]': variant === 'text',
        'rounded-full': variant === 'circular',
        'rounded-lg': variant === 'rectangular',
      },
      className
    );

    return (
      <div
        ref={ref}
        className={baseStyles}
        style={{
          width: variant === 'text' ? undefined : width,
          height: variant === 'text' ? undefined : height,
        }}
        {...props}
      />
    );
  }
);
Skeleton.displayName = 'Skeleton';

export { Skeleton };